<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading">


      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>项目信息</span>
        </div>
        <el-form  label-width="150px" class="form viewFormWrapper">
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="项目编号：" >
                        <span class="activeColor">{{ form.tenderProjectCode }} </span>
                    </el-form-item>
                </el-col>
              <el-col :span="12">
                  <el-form-item label="项目名称：">
                      <span class="activeColor">{{ form.tenderProjectName }}</span>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="开标时间：" >
                        <span class="activeColor">{{ form.bidopenTime }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开标室：">
                        <span class="activeColor">{{ form.openFieldName || '-'}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="评标预计开始时间：" >
                        <span class="activeColor">{{ form.evalStime }} </span>
                    </el-form-item>
                </el-col>
              <el-col :span="12">
                  <el-form-item label="评标预计结束时间：" >
                      <span class="activeColor">{{ form.evalEtime }}</span>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="评标室：" >
                        <span class="activeColor">{{ form.evalFieldName || '-' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所属机构：" >
                        <span class="activeColor">{{ form.orgName }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
      </el-card>
      <el-card class="box-card" :style="{'margin-bottom':'0px'}" >
          <div slot="header" class="clearfix">
              <span>参与人员信息</span>
              <el-button size="mini" style="float: right" icon="el-icon-plus" type="primary" v-if="hasBtnPermission('btn_jz_tradding_actives_edit')" @click="showPersonInfoWindow()">新增</el-button>
          </div>
          <el-row :gutter="15" style="position: relative" :style="{'min-height':cardMinHeight}" >
              <el-col :span="8" v-for="item in personList" :key="item.id">
                  <el-card class="projectCard">
                      <h3>{{item.personName}}</h3>
                      <el-tag :type="formatterTagType(item.personRole,'roleType')"
                              size="small"
                              :hit="false"
                              effect="plain"> {{ formatterDataDictionary(rolesList,item.personRole)}}
                      </el-tag>
                      <el-button style="position:absolute;right:10px;top:10px;z-index: 100" type="primary" size="mini" icon="el-icon-edit" v-if="hasBtnPermission('btn_jz_tradding_actives_edit')" plain @click="showPersonInfoWindow(item)"></el-button>
                      <p style="margin:0 16px"><span :title="item.idcard" class="activeColor">{{item.idcard}}</span></p>
                      <p class="info"><span>允许进入评标区域：</span>
                          <el-switch
                              v-if="edit && hasBtnPermission('btn_jz_tradding_actives_updateEntry')"
                              v-model="item.allowCome"
                              @change="updateUserAllowInfo($event,item)"
                              :active-value="1"
                              :inactive-value="0"
                              active-color="#13ce66"
                              inactive-color="#c0c0c0">
                          </el-switch>
                          <span v-else>{{item.allowCome == 1?'是':'否'}}</span>
                      </p>
                  </el-card>
              </el-col>
              <emptyInfo v-if="personList.length == 0" :emptyMsg="'暂无人员'" ></emptyInfo>

          </el-row>
      </el-card>

      <el-dialog  :title="personInfoForm.id!=''?'修改参与人员信息':'新增参与人员'" :visible.sync="dialogPersonVisible" width="60%">
          <div class="dialogBox">
              <el-form ref="personInfoForm"
                       :model="personInfoForm"
                       :rules='personInfoFormRules'
                       label-width="150px"
                       class="form">
                  <el-row>
                      <el-col :span="12">
                          <el-form-item label="姓名：" prop='personName' style="width:100%;">
                              <el-input v-model="personInfoForm.personName" maxlength="6" show-word-limit></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="身份证号：" prop='idcard' style="width:100%;"  >
                              <el-input v-model="personInfoForm.idcard" maxlength="18" show-word-limit></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="允许进入评标区域：" style="width:100%;"  >
                              <el-switch
                                      v-model="personInfoForm.allowCome"
                                      :active-value="1"
                                      :inactive-value="0"
                                      active-color="#13ce66"
                                      inactive-color="#c0c0c0">
                              </el-switch>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="人员角色：" prop='personRole' style="width:100%;"  >
                              <el-select v-model="personInfoForm.personRole" clearable value-key="value" style="width:100%;">
                                  <el-option v-for="(item,index) in rolesList"
                                             :key="index"
                                             :label="item.name"
                                             :value="item.value">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                  </el-row>
              </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
               <el-button @click="closeDialog()" class="backBtn">返回</el-button>
               <el-button type="primary" @click="savePersonInfo" style="margin-bottom:20px;">保存</el-button>
          </span>
      </el-dialog>



  </div>
</template>

<script>
    import emptyInfo from '@/components/empty-info';
    import {mapState} from "vuex";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import {isIdcard} from "@/utils/validate";


    export default {
  components: {
      emptyInfo
  },
    props: ['mainContentViewHeight'],
  data() {
    return {
      id: "",
      edit:false,
      cardMinHeight: (document.documentElement.clientHeight - 468) + 'px',
      form: {
        id: '',
        projectCode: '',
        projectName:'',
        bidName:'',
        tenderName:'',
        tenderAgentName:'',
        projectHandleTime:'',
        tenderNoticeTime:'',
        tenderFileTime:'',
        evalprofExtractTime:'',
        bidopenAddress:'',
        bidopenTime:'',
        evalTime:'',
        evalAddress:'',
        candidateTime:'',
        resultNoticeTime:'',
        noficationTime:'',
        winerName:'',
        winBidprice:'',
        winWorkItem:'',
        winProjectMainer:'',
      },
        personList:[],
        personInfoForm: {
            id: "",
            personRole:"",
            idcard: "",
            personName: "",
            allowCome:1,
        },
        personInfoFormRules: {
            personName: [{required: true, message: '请输入姓名', trigger: 'blur'},{ min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }],
            idcard: [{required: true, message: '请输入身份证号', trigger: 'blur'}, {
                validator: isIdcard,
                trigger: 'blur'
            }],
            personRole: [
                { required: true, message: '请选择角色', trigger: 'change' }
            ],
        },
        dialogPersonVisible:false,
      questName:'',  //申请单位
      questReason: '',  //申请出证原因
      disable:false,
      loading: false,
      user: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数

      submitBtn:false,
        rolesList:[],
      dataId: 0,
      formId: '',
      groupList: [],
      formInfo: {},
      tableData: [],


    }
  },

  filters: {},
  created() {
      this.getDic('jz_dgwitness_person_role');
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    })
  },

  activated() {

    // $route.query.id为首页通过 url跳转 带过来的参数
      this.id = (this.$route.query && this.$route.query.id) || (this.$route.params && this.$route.params.id) || '';
      this.edit = (this.$route.query && this.$route.query.edit) || (this.$route.params && this.$route.params.edit) || '';
      this.getDetailById();
  },

  methods: {
    //列表查看进来根据id查询详情
    getDetailById() {

      if (this.id) {


        // 查询基本信息
        this.$http.get('/fieldApply/jzTrading/get?id=' + this.id).then(res => {
          if (res.data.code === '1') {
            const data = res.data.data;
            this.form = {...data};
          }
        })
        this.getPersonList()

      } else {
        this.$router.push({
          name: 'home'
        })
      }

    },
      getPersonList(){
          // 查询人员信息信息
          this.$http.get('/fieldAppLys/jzTradDingParTers/getByProjectId?projectId=' + this.id).then(res => {
              if (res.data.code === '1') {
                  this.personList = res.data.data.rows;
              }
          })
      },

      closeDialog() {
          if(this.dialogPersonVisible ){
              this.dialogPersonVisible= false;
              this.$refs.personInfoForm.resetFields();
          }
      },
      showPersonInfoWindow(item) {

        if(item){
            this.personInfoForm = {...item};
            this.personInfoForm.personRole = item.personRole.toString();
        }else{
            this.personInfoForm = {
                id: "",
                personRole:"",
                idcard: "",
                personName: "",
                allowCome:1,
            }
        }
          this.dialogPersonVisible = true;

      },
      savePersonInfo() {
          this.$refs['personInfoForm'].validate((valid) => {
              if (valid) {
                  let allowCome = this.personInfoForm.allowCome == 1?true:false;
                  this.personInfoForm.parentId = this.id;
                  this.updateUserAllowInfo(allowCome,this.personInfoForm)
              }
          })
      },

      updateUserAllowInfo(bool,item){
          item.allowCome = bool;
          this.$http.post('/fieldAppLys/jzTradDingParTers/save', item,).then(res => {
              if (res.data.code == 1) {
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  })
                  this.closeDialog()
                  this.getPersonList()
              } else {
                  this.$message({
                      type: 'error',
                      message: res.data.msg
                  })
              }
          })

      },

      getDic(type) { // 获取字典

          this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
              if (res.data.code === '1') {
                  switch (type) {
                      case 'jz_dgwitness_person_role':this. rolesList = res.data.data;break;
                  }
              }
          })
      },
    // 返回
    back() {
        // this.$router.go(-1);

        tabsCloseCurrentHandle();
        this.$router.push({
            name:'trading_activity_list',
        })

    },



  },
  deactivated() {
  },


}
</script>

<style lang="less" scope>
    .box-card{

        .projectCard{
            .el-card__body{
                padding: 0;
            }
            .el-card__header{
                padding: 0;
            }
            h3{
                display: inline-block;
                margin:16px 6px 16px 16px;
            }
            p.info{
                margin:0;
                margin: 16px;
            }

        }

    }



</style>